// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-btn {
  font-weight: 500;
}

.note-date, .note-contact {
  font-size: 10px;
  font-weight: 400;
  color: #777;
}

.note-contact {
  font-weight: 400;
  font-size: 11px;
}

.note-note {
  font-size: 12px;
  font-weight: 500;
}

div .customer-note {
  padding: 5px;
  margin-bottom: 1px;
  border-radius: 5px;
}

div .customer-note:nth-of-type(odd) {
  background-color: #f4f4f4 !important;
}

div .customer-note:nth-of-type(even) {
  background-color: #eee !important;
}

.sleep-until {
  font-size: 11px;
  padding-right: 35px;
}

.btn-1 {
  background-color: var(--successColour) !important;
  color: #fff !important;
}

.btn-2 {
  background-color: #d4af37 !important;
  color: #fff !important;
}

.btn-3 {
  background-color: #c00 !important;
  color: #fff !important;
}

.btn-4 {
  background-color: rgb(120, 120, 120) !important;
  color: #fff !important;
}

.role-info {
  font-size: 0.6rem;
  background-color: #ddd;
  font-weight: 600;
  padding: 3px 5px;
  border-radius: 5px;
  margin-right: 5px;
}

.seller {
  background-color: #437381 !important;
  color: white;
}

.buyer {
  background-color: #734381 !important;
  color: white;
}

.sticky-column {
  --first-column-width: 70px;
  --last-column-width: 80px;
}

.sticky-column {
  overflow-x: scroll;
}
.sticky-column.sticky-first-column tr th:first-child, .sticky-column.sticky-first-column tr td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  min-width: var(--first-column-width);
}
.sticky-column.sticky-last-column tr th:last-child, .sticky-column.sticky-last-column tr td:last-child {
  position: sticky;
  right: 0;
  z-index: 2;
  min-width: var(--last-column-width);
}
.sticky-column tr th:first-child, .sticky-column tr td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
}
.sticky-column thead th {
  background-color: #fff;
}
.sticky-column tbody tr:nth-of-type(odd) td {
  background-color: var(--tableStripedBackgroundColour) !important;
}
.sticky-column tbody tr:nth-of-type(even) td {
  background-color: #fff !important;
}

.note-icon {
  font-size: 1.3rem;
}

.badge2 {
  border-radius: 20px;
  min-width: 20px !important;
  min-height: 20px !important;
  line-height: 20px;
  color: #fff !important;
  font-size: 0.7rem;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
}

.liveBadge {
  background-color: var(--primaryButtonColour);
  color: #fff !important;
}

.totalBadge {
  background-color: var(--secondaryButtonColour);
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/customer/customer-search/customer-search.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,iDAAA;EACA,sBAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;AACF;;AAEA;EACE,iCAAA;EACA,sBAAA;AACF;;AAEA;EACE,+CAAA;EACA,sBAAA;AACF;;AAGA;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,YAAA;AAAF;;AAGA;EACE,oCAAA;EACA,YAAA;AAAF;;AAGA;EAEE,0BAAA;EACA,yBAAA;AADF;;AAIA;EAEE,kBAAA;AAFF;AAKI;EACE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,oCAAA;AAHN;AAQI;EACE,gBAAA;EACA,QAAA;EACA,UAAA;EACA,mCAAA;AANN;AAUE;EACE,gBAAA;EACA,OAAA;EACA,UAAA;AARJ;AAWE;EACE,sBAAA;AATJ;AAiBI;EACE,gEAAA;AAfN;AAkBI;EACE,iCAAA;AAhBN;;AAqBA;EACE,iBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,4CAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,8CAAA;AAlBF","sourcesContent":[".status-btn {\n  font-weight: 500;\n}\n\n.note-date, .note-contact {\n  font-size: 10px;\n  font-weight: 400;\n  color: #777;\n}\n\n.note-contact {\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.note-note {\n  font-size: 12px;\n  font-weight: 500;\n}\n\ndiv .customer-note {\n  padding: 5px;\n  margin-bottom: 1px;\n  border-radius: 5px;\n}\n\ndiv .customer-note:nth-of-type(odd) {\n  background-color: #f4f4f4 !important;\n}\n\ndiv .customer-note:nth-of-type(even) {\n  background-color: #eee !important;\n}\n\n.sleep-until {\n  font-size: 11px;\n  padding-right: 35px;\n}\n\n.btn-1 {\n  background-color: var(--successColour) !important;\n  color: #fff !important;\n}\n\n.btn-2 {\n  background-color: #d4af37 !important;\n  color: #fff !important;\n}\n\n.btn-3 {\n  background-color: #c00 !important;\n  color: #fff !important;\n}\n\n.btn-4 {\n  background-color: rgb(120, 120, 120) !important;\n  color: #fff !important;\n}\n\n\n.role-info {\n  font-size: 0.6rem;\n  background-color: #ddd;\n  font-weight: 600;\n  padding: 3px 5px;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n\n.seller {\n  background-color: #437381 !important;\n  color: white;\n}\n\n.buyer {\n  background-color: #734381 !important;\n  color: white;\n}\n\n.sticky-column {\n\n  --first-column-width: 70px;\n  --last-column-width: 80px;\n}\n\n.sticky-column {\n\n  overflow-x: scroll;\n\n  &.sticky-first-column tr {\n    th:first-child, td:first-child {\n      position: sticky;\n      left: 0;\n      z-index: 2;\n      min-width: var(--first-column-width);\n    }\n  }\n\n  &.sticky-last-column tr {\n    th:last-child, td:last-child {\n      position: sticky;\n      right: 0;\n      z-index: 2;\n      min-width: var(--last-column-width);\n    }\n  }\n\n  tr th:first-child, tr td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 2;\n  }\n\n  thead th {\n    background-color: #fff;\n  }\n\n  th:not(:first-child):not(:last-child), td:not(:first-child):not(:last-child) {\n    // min-width: 180px !important;\n  }\n\n  tbody {\n    tr:nth-of-type(odd) td {\n      background-color: var(--tableStripedBackgroundColour) !important;\n    }\n\n    tr:nth-of-type(even) td {\n      background-color: #fff !important;\n    }\n  }\n}\n\n.note-icon {\n  font-size: 1.3rem;\n}\n\n.badge2 {\n  border-radius: 20px;\n  min-width: 20px !important;\n  min-height: 20px !important;\n  line-height: 20px;\n  color: #fff !important;\n  font-size: 0.7rem;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n}\n\n.liveBadge {\n  background-color: var(--primaryButtonColour);\n  color: #fff !important;\n}\n\n.totalBadge {\n  background-color: var(--secondaryButtonColour);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
